import { render } from "./Form.vue?vue&type=template&id=1afcdc8e"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Form.vue?vue&type=style&index=0&id=1afcdc8e&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__